// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n\n.notice_popup\n{\n   position:relative;\n   width:100% !important;\n   top:50% !important;\n   left:50% !important;\n   z-index:1 !important;\n   transform:translate(-50%,-50%) !important;\n}\n", ""]);
// Exports
module.exports = exports;
